/**
 * Custom JavaScript for Dragonfly Brand
 * Mobile text switching for add to cart and checkout buttons
 */

document.addEventListener('DOMContentLoaded', function() {
  // Debounce function to limit resize event firing
  function debounce(func, wait) {
    var timeout;
    return function executedFunction() {
      var later = function() {
        clearTimeout(timeout);
        func();
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Mobile text switching for add to cart and checkout buttons
  function mobileTextSwitcher() {
    var isMobile = window.matchMedia('(max-width: 769px)').matches;
    
    // Handle add to cart buttons
    var addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(function(button) {
      var desktopText = button.querySelector('.add-to-cart-text--desktop');
      var mobileText = button.querySelector('.add-to-cart-text--mobile');
      
      if (desktopText && mobileText) {
        if (isMobile) {
          desktopText.style.display = 'none';
          mobileText.style.display = 'inline';
        } else {
          desktopText.style.display = 'inline';
          mobileText.style.display = 'none';
        }
      }
    });
    
    // Handle checkout buttons
    var checkoutButtons = document.querySelectorAll('[data-mobile-text]');
    checkoutButtons.forEach(function(button) {
      var desktopText = button.querySelector('.checkout-text--desktop');
      var mobileText = button.querySelector('.checkout-text--mobile');
      
      if (desktopText && mobileText) {
        if (isMobile) {
          desktopText.style.display = 'none';
          mobileText.style.display = 'inline';
        } else {
          desktopText.style.display = 'inline';
          mobileText.style.display = 'none';
        }
      }
    });
  }

  // Initialize mobile text switching
  mobileTextSwitcher();
  
  // Debounced resize handler for better performance
  var debouncedSwitcher = debounce(mobileTextSwitcher, 150);
  
  // Update on window resize (debounced)
  window.addEventListener('resize', debouncedSwitcher);
  
  // Use MediaQuery listener for more efficient breakpoint detection
  var mediaQuery = window.matchMedia('(max-width: 769px)');
  mediaQuery.addListener(function(e) {
    mobileTextSwitcher();
  });
  
  // Also run after page loads (for dynamically loaded content)
  document.addEventListener('page:loaded', mobileTextSwitcher);
  
  // Run on orientation change for mobile devices
  window.addEventListener('orientationchange', function() {
    setTimeout(mobileTextSwitcher, 100);
  });
});